import camelcaseKeys from "camelcase-keys";

import { apiSlice } from "@/lib/rtkquery";
import { ApiResponse } from "@/types";

import type { FireSafetyEquipmentDTO } from "../types";

type FireSafetyEquipmentResponse = ApiResponse<FireSafetyEquipmentDTO[]>;

export const fireSafetyEquipmentApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getFireSafetyEquipmentCount: build.query<FireSafetyEquipmentDTO[], void>({
      query: () => "api/v1/fire_safety_equipment",
      transformResponse: (response: FireSafetyEquipmentResponse) =>
        camelcaseKeys(response.results),
    }),
  }),
});

export const { useGetFireSafetyEquipmentCountQuery } = fireSafetyEquipmentApi;
